import { useInitSession } from '@btime/react-session'
import { useMutation, gql } from '@apollo/client'
import { navigate } from '@reach/router'

import { getSubdomain } from '../../../../utils/helpers/url'
import { sessionsClient } from '../../../../utils/apollo/api'
import * as tracker from '@btime/tracker'

const MUTATION = gql`
  mutation Login($ssoToken: String, $userId: Int) {
    login(input: { ssoToken: $ssoToken, userId: $userId }, origin: "web", repleaceSession: true) {
      token
      permissions {
        enabled
        name
      }
      user {
        id
        name
        email
        master
      }
    }
  }
`

const useSsoLoginRequest = (ssoToken, userId) => {
  const [request, state] = useMutation(MUTATION, { client: sessionsClient })
  const initSession = useInitSession()

  const handleRequest = async e => {
    e.preventDefault()

    return request({ variables: { ssoToken, userId: Number(userId) } }).then(resp => {
      if (!resp.errors) {
        const session = resp.data.login
        const workspace = getSubdomain()
        initSession({ ...session, workspace })
        tracker.signIn(session.user, workspace)
        navigate('/')
      } else {
        console.error(resp.errors)
      }
    })
  }

  return [handleRequest, state]
}

export default useSsoLoginRequest
